var Column = require('./column')
var ActionCellView = require('../table/action-cell-view')

module.exports = Column.extend({
    cellViewClass: ActionCellView
})
